import React from 'react'
import { Link } from 'react-router-dom'

const EmptyCart = () => {
  return (
    <div>
      <h1 className="yourcart">EMPTY</h1>
      <h1 className="yourcart">
        <Link className="backShop" to="/shop">
          shopping now!
        </Link>
      </h1>
    </div>
  )
}

export default EmptyCart